/**
 * Presentation metadata for in-app notifications.
 *
 * `model` drives the category chip and comes from the API's NOTIFICATION_MODELS;
 * `severity` drives the chip colour. Kept as lookup tables so a new notification
 * type in the backend catalog does not require touching the component -- an
 * unknown value falls back instead of rendering nothing.
 */
const NOTIFICATION_MODEL_LABELS = {
  invoice: 'Facturas',
  payment: 'Pagos',
  subscription: 'Suscripciones',
  agent: 'Agentes'
}

const NOTIFICATION_SEVERITY_COLORS = {
  info: 'primary',
  warning: 'orange darken-2',
  critical: 'red darken-1'
}

const notificationModelLabel = (model) => NOTIFICATION_MODEL_LABELS[model] || 'General'

const notificationSeverityColor = (severity) =>
  NOTIFICATION_SEVERITY_COLORS[severity] || NOTIFICATION_SEVERITY_COLORS.info

export {
  NOTIFICATION_MODEL_LABELS,
  NOTIFICATION_SEVERITY_COLORS,
  notificationModelLabel,
  notificationSeverityColor
}
